import {BaseService} from "./base-service";
import {DomUtils} from "../utils/dom-utils";
import {LoggerUtils} from "../utils/logger/logger-utils";
import {SiteConfig} from "../../core/bootstrap/models/site-config";
import {contractsUtils} from "../utils/contracts-utils";
import {DeviceStore} from "../../core/app/device.store";

export class BaseUtilsService extends BaseService {
  domUtils: DomUtils;
  logger: LoggerUtils;
  siteConfig: SiteConfig;
  deviceStore: DeviceStore;

  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore];

  constructor(
    domUtils: DomUtils,
    logger: LoggerUtils,
    siteConfig: SiteConfig,
    deviceStore: DeviceStore,
  ) {
    super();

    contractsUtils.requiredType(domUtils, DomUtils);
    contractsUtils.requiredType(logger, LoggerUtils);
    contractsUtils.requiredType(siteConfig, SiteConfig);
    contractsUtils.requiredType(deviceStore, DeviceStore);

    this.domUtils = domUtils;
    this.logger = logger;
    this.siteConfig = siteConfig;
    this.deviceStore = deviceStore;
  }
}
